import { Controller } from "@hotwired/stimulus"

// Loads the states and cities of the address fields with the loader registration and the profile use
// (src/address_relations_loader.js), since those fields can arrive later in a Turbo frame. The loader looks only
// inside this element, so a page with its own address fields behind the sidenav is left alone.
export default class extends Controller {
  connect() {
    window.addressRelationsLoader?.initialize({ root: this.element })
  }
}
